import { render, staticRenderFns } from "./NguonTinTucList.vue?vue&type=template&id=f6d3c59a"
import script from "./NguonTinTucList.vue?vue&type=script&lang=js"
export * from "./NguonTinTucList.vue?vue&type=script&lang=js"
import style0 from "./NguonTinTucList.vue?vue&type=style&index=0&id=f6d3c59a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports